export default __webpack_public_path__ + "static/playStoreIcon-648b8f13508b078b9c1bf50de38b60d2.svg";